import klh from "./klhPalette";

/**
 * Palet grafik — diturunkan dari ramp Design System KLH/BPLH v2.1 dan sudah
 * DIVALIDASI dengan validator palet (bukan dikira-kira).
 *
 * TEMUAN PENTING — ramp hijau DS tidak bisa dipakai sebagai warna seri:
 * setiap langkahnya gagal salah satu dari dua syarat keterbacaan grafik.
 *   g-300 #7CDED6  L 0.838 (di atas pita 0.43-0.77) · C 0.094 (di bawah lantai 0.10)
 *   g-400 #25D0C2  L 0.774 (tepat di luar pita)
 *   g-500 #07887D  C 0.098 (terbaca abu-abu)
 *   g-600 #005952  L 0.417 · C 0.073
 *   g-700 #00453F  L 0.351 · C 0.062
 * Hijau KLH adalah teal gelap yang rendah kroma — bagus untuk identitas dan
 * tombol, tidak bisa dibedakan sebagai warna data. Ini sejalan dengan peran
 * warna yang ditetapkan DS sendiri: "Biru — informasi & data ... visualisasi".
 * Karena itu palet kategorikal di bawah dibangun dari biru dan oranye saja.
 *
 * Hasil validasi (mode terang, permukaan #FFFFFF):
 *   Pita terang        LULUS  8 dari 8 di dalam L 0.43-0.77
 *   Lantai kroma       LULUS  8 dari 8 >= 0.10
 *   Separasi CVD       LULUS  terburuk bersebelahan dE 25.4 (protan)
 *   Lantai normal      LULUS  terburuk bersebelahan dE 30.1
 *   Kontras permukaan  PERINGATAN  #F97910 (2.7:1) dan #FA8F38 (2.32:1) di bawah 3:1
 *
 * KEWAJIBAN dari peringatan kontras: dua oranye paling terang tidak boleh
 * berdiri sendiri sebagai pembawa makna. Keduanya sengaja ditaruh di slot 6 dan
 * 8 supaya hanya terpakai saat seri sudah banyak, dan legenda Highcharts wajib
 * tetap menyala. Peringatan ini tidak boleh diabaikan begitu saja.
 *
 * Urutan warna bersifat TETAP dan tidak boleh diputar. Seri ke-9 dan seterusnya
 * digabung menjadi "Lainnya" atau dipecah jadi beberapa grafik kecil — bukan
 * diberi warna baru hasil generate.
 */
export const chartCategorical = [
  klh.blue[600], // #0E66C4
  klh.orange[700], // #AE5104
  klh.blue[400], // #4596ED
  klh.orange[600], // #D66305
  klh.blue[700], // #0B529D
  klh.orange[500], // #F97910  kontras 2.7:1 — butuh label/legenda
  klh.blue[500], // #147DEF
  klh.orange[400], // #FA8F38  kontras 2.32:1 — butuh label/legenda
];

/**
 * Skala sekuensial (besaran) — satu hue, terang ke gelap.
 * Validasi ordinal: monotonisitas terang LULUS, jarak antar-langkah LULUS,
 * ujung terang 2.26:1 terhadap permukaan LULUS, sebaran hue 5 derajat LULUS.
 * b-100 dan b-200 sengaja dibuang: keduanya di bawah lantai kontras 2:1.
 */
export const chartSequential = [
  klh.blue[300],
  klh.blue[400],
  klh.blue[500],
  klh.blue[600],
  klh.blue[700],
  klh.blue[800],
];

/**
 * Skala divergen (polaritas) — dua hue dengan titik tengah netral.
 * Mengikuti aturan struktural design system; validator tidak punya mode
 * divergen sehingga skala ini TIDAK melewati pemeriksaan skrip.
 */
export const chartDiverging = [
  klh.orange[800],
  klh.orange[600],
  klh.orange[400],
  klh.neutral.surface3, // titik tengah netral
  klh.blue[400],
  klh.blue[600],
  klh.blue[800],
];

/** Warna status — DIPESAN, tidak boleh dipakai ulang sebagai warna seri. */
export const chartStatus = {
  success: klh.status.success,
  warning: klh.status.warning,
  danger: klh.status.danger,
  info: klh.status.info,
};

const chartPalette = {
  categorical: chartCategorical,
  sequential: chartSequential,
  diverging: chartDiverging,
  status: chartStatus,
};

export default chartPalette;
